// src/services/adminRevenueAnalyticsApi.js

import api from '../api';

const ALLOWED_NETWORKS = [
  'mainnet',
  'testnet',
];

const ALLOWED_PERIODS = [
  7,
  30,
  90,
  'all',
];

const normalizeNetwork = (network) => {
  return ALLOWED_NETWORKS.includes(network)
    ? network
    : 'mainnet';
};

const normalizeDays = (days) => {
  if (days === 'all') {
    return 'all';
  }

  const numericDays = Number(days);

  return ALLOWED_PERIODS.includes(numericDays)
    ? numericDays
    : 30;
};

const getBannerRevenueAnalytics = async ({
  days = 30,
  network = 'mainnet',
} = {}) => {
  const safeDays = normalizeDays(days);
  const safeNetwork = normalizeNetwork(network);

  const response = await api.get(
    '/admin/revenue-analytics/banners',
    {
      params: {
        days: safeDays,
        network: safeNetwork,
      },
      headers: {
        'X-Network': safeNetwork,
      },
    }
  );

  return response.data;
};

const adminRevenueAnalyticsApi = {
  getBannerRevenueAnalytics,
};

export {
  getBannerRevenueAnalytics,
};

export default adminRevenueAnalyticsApi;
